var React = require('react');

function ArticlesArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 2.5L11 8L5.5 13.5","stroke":"white","strokeOpacity":"0.25","strokeWidth":"2","strokeLinecap":"round"}));
}

ArticlesArrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArticlesArrow;

ArticlesArrow.default = ArticlesArrow;
